class ListSection {
  constructor(elem) {
    this.init(elem)
  }

  init(elem) {
    this.elem = elem;
    this.initListeners();
  }

  initListeners() {
    this.elem.querySelectorAll('[data-list="item"]').forEach( item => {
      let trigger = item.querySelector('[data-list="trigger"]');

      if (trigger) {
        trigger.addEventListener('click', () => {
          this.toggle(item);
        })
      } else {
        this.toggle(item)
      }
    })
  }

  open(item) {
    item.classList.add('open')
  }

  close(item) {
    item.classList.remove('open');
  }

  toggle(item) {
    if (item.classList.contains('open')) {
      return this.close(item)
    }
    return this.open(item)
  }
}

export default ListSection



// WEBPACK FOOTER //
// ./scripts/libs/ListSection.js